(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.accountSelectorReact = svs.numbergames.accountSelectorReact || {};

 })(window);